// extracted by mini-css-extract-plugin
export default {"container":"oiUov","body":"Xfm4T","social-actions":"CXXEX","copy-to-clipboard-button":"XveF4","copy-to-clipboard-input":"aOZYH"};